const emailTo = (v, f) => {
    const defaultEmailAddress = 'SEORecruitingpages@perfect-vision.com';
    const objTypeVal = f.getPrimaryIndustry ? v.PrimaryIndustry : 'default';
    const emailObj = f.emailTo.find((obj) => obj.type.toLowerCase() === objTypeVal.toLowerCase());
    if (emailObj) {
        return emailObj.emailAddress;
    }
    return defaultEmailAddress;
};

const createPartnerBody = (v, f) => {
    const thisURL = `${window.location.protocol}//${window.location.host}/${window.location.pathname}`;
    const body = JSON.stringify({
        FullName: v.FullName,
        FirstName: v.FirstName,
        LastName: v.LastName,
        CompanyName: v.Company,
        ContactPhoneNumber: v.Phone,
        ContactEmail: v.Email,
        ContactZipCode: v.ZipCode,
        PrimaryIndustry: v.PrimaryIndustry,
        PrimaryIndustryOther: v.PrimaryIndustry === 'Other' ? v.PrimaryIndustryOther : '',
        HowDidYouHear: v.HowDidYouHear,
        HowDidYouHearOther: v.HowDidYouHear === 'Other' ? v.HowDidYouHearOther : '',
        RecruitingTypeID: f.recruitingTypeId,
        EmailTo: emailTo(v, f),
        RecruitingPageLink: thisURL,
        RecruitingPageType: f.formType,
        ReferringURL: document.referrer,
    });
    return body;
};

const createBecomeAnAuthorizedDealerBody = (v, f) => {
    const thisURL = `${window.location.protocol}//${window.location.host}/${window.location.pathname}`;
    const body = JSON.stringify({
        FirstName: v.FirstName,
        LastName: v.LastName,
        CompanyName: v.CompanyName,
        Email: v.Email,
        City: v.City,
        State: v.State,
        Phone: v.Phone,
        ZipCode: v.ZipCode,
        CurrentBusinessOwner: v.CurrentBusinessOwner,
        ProgramsInterestedIn: v.ProgramsInterestedIn,
        HearAbout: v.HearAbout,
        TypeOfBusiness: v.TypeOfBusiness,
        EmailTo: emailTo(v, f),
        AdditionalComments: v.AdditionalComments,
        InstallationInterested: v.InstallationInterested,
        SmallMediumBusinessInterested: v.SmallMediumBusinessInterested,
    });
    return body;
};

const createBecomeContractPartnerBody = (v, f) => {
    const thisURL = `${window.location.protocol}//${window.location.host}/${window.location.pathname}`;
    const body = JSON.stringify({
        FirstName: v.FirstName,
        LastName: v.LastName,
        Email: v.Email,
        ZipCode: v.ZipCode,
        Phone: v.Phone,
        CurrentTechnician: v.CurrentTechnician,
        InstallationServicesInterestedIn: v.InstallationServicesInterestedIn,
        InstallationTypesInterestedIn: v.InstallationTypesInterestedIn,
        EmailTo: emailTo(v, f),
    });
    return body;
};

const createInstallationServicesRequestBody = (v, f) => {
    const thisURL = `${window.location.protocol}//${window.location.host}/${window.location.pathname}`;
    const body = JSON.stringify({
        FirstName: v.FirstName,
        LastName: v.LastName,
        Phone: v.Phone,
        Email: v.Email,
        CompanyName: v.CompanyName,
        GeographicalLocationInterestedIn: v.GeographicalLocationInterestedIn,
        HowSoonDoYouNeedTechnicians: v.HowSoonDoYouNeedTechnicians,
        WorkOrderVolumeMonthly: v.WorkOrderVolumeMonthly,
        WhatCanWeHelpYouWith: v.WhatCanWeHelpYouWith,
        InstallationServicesInterestedIn: v.InstallationServicesInterestedIn,
        InstallationTypesInterestedIn: v.InstallationTypesInterestedIn,
        EmailTo: emailTo(v, f),
    });
    return body;
};

const createWirelessInfrastructureBody = (v, f) => {
    const thisURL = `${window.location.protocol}//${window.location.host}/${window.location.pathname}`;
    const body = JSON.stringify({
        FirstName: v.FirstName,
        LastName: v.LastName,
        CompanyName: v.CompanyName,
        Email: v.Email,
        City: v.City,
        State: v.State,
        Phone: v.Phone,
        ZipCode: v.ZipCode,
        RequestACatalog: v.RequestACatalog,
        RequestAQuote: v.RequestAQuote,
        CustomerAccountRequest: v.CustomerAccountRequest,
        ProgramsInterestedIn: v.ProgramsInterestedIn,
        EmailTo: emailTo(v, f),
        HearAbout: v.HearAbout,
        OtherSource: v.OtherSource,
        AdditionalComments: v.AdditionalComments,
    });
    return body;
};

function createContactBody(v) {
    const config = JSON.parse(document.getElementById('ClientApp').getAttribute('data-react'));
    const custID = config.AccountInfo.InvoiceAccount;
    const loginID = config.AccountInfo.LoginId;

    const body = JSON.stringify({
        FullName: v.FullName,
        CompanyName: v.Company,
        ContactPhoneNumber: v.Phone,
        ContactEmail: v.Email,
        ContactZipCode: v.ZipCode,
        HowDidYouHear: v.HowDidYouHear,
        HowDidYouHearOther: v.HowDidYouHear === 'Other' ? v.HowDidYouHearOther : '',
        CustID: custID,
        LoginID: loginID,
    });

    return body;
}

function createSpecsDrawingBody(v, f) {
    const body = JSON.stringify({
        FullName: v.FullName,
        Company: v.Company,
        Phone: v.Phone,
        Email: v.Email,
        ZipCode: v.ZipCode,
        EmailTo: emailTo(v, f),
        HowDidYouHear: v.HowDidYouHear,
        HowDidYouHearOther: v.HowDidYouHear === 'Other' ? v.HowDidYouHearOther : '',
    });

    return body;
}

function getPostBody(v, formData) {
    let body = '';
    switch (formData.formType) {
        case "ADT SafeStreets":
        case 'AT&T Commercial':
        case 'AT&T Residential':
        case 'DIRECTV for Business':
        case 'AT&T':
        case 'CenturyLink':
        case 'Connected Home Solutions':
        case 'Frontier':
        case 'PerfectVision':
        case 'Viasat':
        case 'Windstream':
        case 'Home Security & Automation':
        case 'PVInstallationServices':
        case 'Broadband Dealer':
            body = createPartnerBody(v, formData);
            break;
        case 'BecomeAnAuthorizedDealer':
            body = createBecomeAnAuthorizedDealerBody(v, formData);
            break;
        case 'BecomeContractPartner':
            body = createBecomeContractPartnerBody(v, formData);
            break;
        case 'InstallationServicesRequest':
            body = createInstallationServicesRequestBody(v, formData);
            break;
        case 'WirelessInfrastructure':
            body = createWirelessInfrastructureBody(v, formData);
            break;
        case 'ContactUs':
            body = createContactBody(v);
            break;
        case 'specsDrawingsRequest':
            body = createSpecsDrawingBody(v, formData);
            break;
        default:
            break;
    }
    return body;
} 

function getAPIEndPoint(type) {
    let url = '';
    switch (type) {
        case 'ADT SafeStreets':
        case 'AT&T Commercial':
        case 'AT&T Residential':
        case 'DIRECTV for Business':
        case 'AT&T':
        case 'CenturyLink':
        case 'Connected Home Solutions':
        case 'Frontier':
        case 'PerfectVision':
        case 'Viasat':
        case 'Windstream':
        case 'Home Security & Automation':
        case 'PVInstallationServices':
        case 'Broadband Dealer':
            url = '/api/recruiting/DealerRequest';
            break;
        case 'ContactUs':
            url = '/api/contact/form';
            break;
        case 'specsDrawingsRequest':
            url = '/api/Resources/specsDrawingsRequest';
            break;
        case 'BecomeAnAuthorizedDealer':
            url = '/api/Resources/BecomeAnAuthorizedDealer';
            break;
        case 'WirelessInfrastructure':
            url = '/api/Resources/WirelessInfrastructure';
            break;
        case 'BecomeContractPartner':
            url = '/api/Resources/BecomeContractPartner';
            break;
        case 'InstallationServicesRequest':
            url = '/api/Resources/InstallationServicesRequest';
            break;
        default:
            break;
    }
    return url;
}

export { getPostBody, getAPIEndPoint };
export default getPostBody;
